export interface GetWithholdingListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetWithholdingListPagingAndFilterResponseData
}

export interface GetWithholdingListPagingAndFilterResponseData {
    items: GetWithholdingListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetWithholdingListPagingAndFilterResponseItem {
    withholdingId: string
    startDate: string
    endDate: string
    withholdingRateId: string
    lowerLimitVatIncluded: number
    description: string
    withholdingRateName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetWithholdingListPagingAndFilterResponseData: GetWithholdingListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}